import { render, staticRenderFns } from "./ConsigneeShipperManagement.vue?vue&type=template&id=e0ba6130&scoped=true"
import script from "./ConsigneeShipperManagement.vue?vue&type=script&lang=ts"
export * from "./ConsigneeShipperManagement.vue?vue&type=script&lang=ts"
import style0 from "./ConsigneeShipperManagement.vue?vue&type=style&index=0&id=e0ba6130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ba6130",
  null
  
)

export default component.exports